<app-loader-bnpl *ngIf="loading" [infoMessage]="infoMsg" ></app-loader-bnpl>
<ng-container *ngIf="validateUserBnpl; else showUserAlert">
    <div class="general-title">
        <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
    </div>
    <app-return-methods [itsMobileCtrl]="true" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()">
    </app-return-methods>
    <div class="contentBox">
        <div class="col-3">
            <div class="info-logo-container">
                <img [src]="information.logo"
                    class="payment_method_no_interactive red" alt="bancolombia logo" />
            </div>
        </div>
        <div class="col-7">
            <div class="methodInfoBnpl">
                <app-return-methods [itsMobileCtrl]="false" [unique]="this.transaction.ORDER_METHOD" (RT)="changeMethod()">
                </app-return-methods>
                <div class="header-bnpl">
                    <img src="assets/images/bnpl/bancolombia/bnpl-header.png" alt="bnpl-header">
                </div>
                <div id="_bevalida_form" class="methodFormBnpl" *ngIf="showForm; else redirectBnpl">
                    <form [formGroup]="form">
                        <!-- name input -->
                        <mat-form-field appearance="outline">
                            <mat-label>{{ 'cc-Name-Input' | translation | async }}</mat-label>
                            <input type="text" name="name" matInput formControlName="name" maxlength="50"
                                placeholder="{{ 'forms-Name-Input' | translation | async }}" />
                        </mat-form-field>
                        <!-- validation input-->
                        <ng-container *ngFor="let validation of errorsMessages.name">
                            <div class="error-message"
                                *ngIf="form.get('name').hasError(validation.type) && (form.get('name').dirty || form.get('name').touched)">
                                {{ validation.message }}
                            </div>
                        </ng-container>
                        <!-- lastName input -->
                        <mat-form-field appearance="outline">
                            <mat-label>{{ 'cc-LastName-Input' | translation | async }}</mat-label>
                            <input type="text" name="lastName" matInput formControlName="lastName" maxlength="50"
                                placeholder="{{ 'forms-Last-Name-Input' | translation | async }}" />
                        </mat-form-field>
                        <!-- validation input-->
                        <ng-container *ngFor="let validation of errorsMessages.lastName">
                            <div class="error-message"
                                *ngIf="form.get('lastName').hasError(validation.type) && (form.get('lastName').dirty || form.get('lastName').touched)">
                                {{ validation.message }}
                            </div>
                        </ng-container>
                        <div class="docContainer">
                           <!-- Document type -->
                           <mat-form-field appearance="outline" class="tipoDoc">
                            <mat-label>{{ 'forms-TypeDoc-Input' | translation | async }}</mat-label>
                            <mat-select placeholder="{{ 'forms-TypeDoc-Input' | translation | async }}" formControlName="typeDI">
                                <mat-option [value]="document.VALUE" *ngFor="let document of listOfDocuments">{{
                                    document.TEXT }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <!-- Document input -->
                         <mat-form-field appearance="outline">
                            <mat-label>{{ 'forms-NumDoc-Input' | translation | async }}</mat-label>
                            <input autocomplete="off" type="text" matInput name="di" maxlength="20" minlength="6"
                                placeholder="{{ 'forms-NumDoc-Input' | translation | async }}" required formControlName="di" />
                        </mat-form-field>
                        </div>
                       <div class="docContainer">
                        <div class="col">
                          <ng-container *ngFor="let validation of errorsMessages.typeDI">
                            <div class="error-message"
                                *ngIf="form.get('typeDI').hasError(validation.type) && (form.get('typeDI').dirty || form.get('typeDI').touched)">
                                {{ validation.message }}
                            </div>
                        </ng-container>
                        </div>
                        <div class="col">
                            <!-- validation input-->
                        <ng-container *ngFor="let validation of errorsMessages.di">
                            <div class="error-message"
                                *ngIf="form.get('di').hasError(validation.type) && (form.get('di').dirty || form.get('di').touched)">
                                {{ validation.message }}
                            </div>
                        </ng-container>
                        </div>
                       </div>
                        <div class="container-phone">
                            <!-- phoneCode input -->
                            <mat-form-field appearance="outline" class="code">
                                <input matInput disabled formControlName="phoneCode">
                            </mat-form-field>
                            <!-- movil input -->
                            <mat-form-field appearance="outline" class="phone">
                                <mat-label>{{ 'forms-NumCel-Input' | translation | async }}</mat-label>
                                <input autocomplete="off" type="text" matInput name="cellPhone"
                                    maxlength="15"
                                    minlength="8"
                                    placeholder="{{ 'forms-NumCel-Input' | translation | async }}" formControlName="cellPhone"
                                    required />
                                <fa-icon matSuffix icon="mobile-alt"></fa-icon>
                            </mat-form-field>
                        </div>
                        <!-- validation input-->
                        <ng-container *ngFor="let validation of errorsMessages.cellPhone">
                            <div class="error-message"
                                *ngIf="form.get('cellPhone').hasError(validation.type) && (form.get('cellPhone').dirty || form.get('cellPhone').touched)">
                                {{ validation.message }}
                            </div>
                        </ng-container>
                        <!-- email input -->
                        <mat-form-field appearance="outline">
                            <mat-label>{{ 'forms-Email-Input' | translation | async }}</mat-label>
                            <input matInput name="email"
                                maxlength="200"
                                minlength="10"
                                placeholder="{{ 'forms-Email-Input' | translation | async }}" formControlName="email"
                                required />
                            <fa-icon matSuffix icon="envelope"></fa-icon>
                        </mat-form-field>
                        <!-- validation input-->
                        <ng-container *ngFor="let validation of errorsMessages.email">
                            <div class="error-message"
                                *ngIf="form.get('email').hasError(validation.type) && (form.get('email').dirty || form.get('email').touched || form.get('email').errors?.pattern)">
                                {{ validation.message }}
                            </div>
                        </ng-container>
                    </form>
                </div>
                <ng-template #redirectBnpl>
                    <div class="divRedirect">
                        <img class="img-error" src="assets/images/error.png" alt="" />
                        <span>{{ infoMessage | translation | async }}</span>
                    </div>
                </ng-template>
            </div>
            <!-- Form button -->
            <app-buttons-bar *ngIf="showForm" [valid]="form.valid" [template]="template" (PAY)="validateData()" class="payButton">
            </app-buttons-bar>
            
            <app-buttons-bar *ngIf="!showForm" [valid]="isValidReturnBtn" [template]="template" [nameCustom]="customMessageBtn"
                (CUSTOM)="changeMethod()">
            </app-buttons-bar>
        </div>
    </div>
</ng-container>

<ng-template #showUserAlert>
    <app-methods-not-found-alert></app-methods-not-found-alert>
</ng-template>
